module.exports = __webpack_public_path__ + "statics/img/cate9-6@2x.0aaff941.png";